import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import PortfolioBreakdownPopup from "./view-breakdown";
import StockBreakdownPopup from "./stockOrder-breakdown";
import MyChartComponent from "./charts-data";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import { svgLogoBase64 } from "../../Constants/config";

const StockList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [isOpenEdit, setisOpenEdit] = useState(false);

  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [startTimeUpdate, setStartTimeUpdate] = useState("");
  const [endTimeUpdate, setEndTimeUpdate] = useState("");
  const [showRecords, setShowRecords] = useState(10);
  const [selected, setSelected] = useState("Download Report");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("id");
  const [status, setStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenStatus, setisOpenStatus] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const DateCalendarRef = useRef();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenDetail, setIsPopupOpenDetail] = useState(false);

  const [stockOrderData, setStockOrderData] = useState([]);
  const [isPopupBreakdownOpen, setisPopupBreakdownOpen] = useState(false);
  const [currentStockId, setcurrentStockId] = useState(0);
  const [isCurrentTab, setIsCurrentTab] = useState("stock");
  const [tab, setTab] = useState("");
  const [changeStatus, setChangeStatus] = useState("");
  const [currentdata, setCurrentData] = useState(null);
  const chartRef = useRef(null);
  const [isMonthOpen, setMonthDropdown] = useState(false);
  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const [pdfData, setPdfData] = useState([]); // Initially hidden
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const location = useLocation();
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [filteredData, setfilteredData] = useState(null);
  const [totalPages, settotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "desc",
  });
  const [currentInvestmentId, setCurrentInvestmentId] = useState("");
  const [totalCount, settotalCount] = useState(0);
  const [openDropdown, setOpenDropdown] = useState(null);
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const monthRef = useRef();
  const downloadRef = useRef();
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = "";
    if (tab == "orders") {
      apiUrl = `${BASE_URL}/v1/investment-request/confirmed-orders/export/excel`;
    } else if (tab == "history" && isCurrentTab == "stock") {
      if (selectedDates.length == 2) {
        apiUrl = `${BASE_URL}/v1/investment-request/purchase-history/export/excel?start_date=${formatDateForFilter(
          selectedDates[0]
        )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl = `${BASE_URL}/v1/investment-request/purchase-history/export/excel`;
      }
    } else {
      if (selectedDates.length == 2) {
        apiUrl =
          filter == ""
            ? `${BASE_URL}/v1/investment-request/stock-purchases/all/export/excel?sort_by=${filterText}&sort_order=${
                sortConfig.direction
              }&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`
            : `${BASE_URL}/v1/investment-request/stock-purchases/all/export/excel?status=${filter}&sort_by=${filterText}&sort_order=${
                sortConfig.direction
              }&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
                selectedDates[0]
              )}&end_date=${formatDateForFilter(selectedDates[1])}`;
      } else {
        apiUrl =
          filter == ""
            ? `${BASE_URL}/v1/investment-request/stock-purchases/all/export/excel?sort_by=${filterText}&sort_order=${sortConfig.direction}&size=100&search=${searchQuery}`
            : `${BASE_URL}/v1/investment-request/stock-purchases/all/export/excel?sort_by=${filterText}&sort_order=${sortConfig.direction}&status=${filter}&size=100&search=${searchQuery}`;
      }
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.blob();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const downloadPDF = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Stock Purchases-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        if ((tab == "history" && isCurrentTab == "stock") || tab == "orders") {
          if (pdfData) {
            setIsHidden(true);
          }
        } else {
          try {
            const response = await GetInvestmentListForPdf();
            if (response.status == 200) {
              if (response.data.stock_purchases.length > 0) {
                setPdfData(response.data.stock_purchases);
                setIsHidden(true);
              } else {
                setPdfData([]);
                setIsHidden(false);
                setIsOpen(false);
                setLoading(false);
                showToast("No data available to generate the report.", "error");
              }
            } else {
              setPdfData([]);
              setIsOpen(false);
              setLoading(false);

              showToast(response.message, "error");
            }
          } catch (err) {
            if (err.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
            setIsOpen(false);
            setLoading(false);

            showToast(err.message, "error");
          }
        }
      }
    }, 1000), // Debounce time
    [filter, filterText, searchQuery, sortConfig, selectedDates, pdfData] // Dependencies
  );
  function createTableBody() {
    const body = document.createElement("tbody");

    pdfData.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");
      if (tab == "history" && isCurrentTab == "stock") {
        tr.innerHTML = `
        <td>${row.code}</td>
        <td>${convertDateFormat(row.date)}</td>
        <td>${convertTimeFormat(row.purchase_time)}</td>
        <td>${row.quantity}</td>
                <td>$${row.price.toFixed(2)}</td>
                <td>$${row.broker_fee.toFixed(2)}</td>
                <td>$${row.gst}</td>

                                <td>${row.total_cost
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
</td>


      `;
      } else if (tab == "orders") {
        tr.innerHTML = `
        <td>${row.code}</td>
        <td>${
          row.last_iap && row.last_iap < 0
            ? "-$" + row.last_iap.toFixed(2)
            : "$" + row.last_iap.toFixed(2)
        }</td>
        <td>$${row.change}</td>
        <td>$${row.bid}</td>
                <td>$${row.ask}</td>
                                <td>$${row.trades}</td>
                <td>${row.vwap}</td>
                <td>${row.volume}</td>
                <td>${row.shares_to_be_purshaed}</td>
                                <td>${row.shares_to_be_sold}</td>
                <td>${row.total_requests}</td>
      `;
      } else {
        tr.innerHTML = `
        <td>${formatDateTime(row.date_created)}</td>
        <td>${row.status == "pending" ? "Pending" : ""}
        ${row.status == "purchased" ? "Purchased" : ""}
        ${row.status == "approved_for_purchase" ? "Approved For Purchase" : ""}
                                  ${
                                    row.status == "purchase_in_progress"
                                      ? "Purchase In Progress"
                                      : ""
                                  }
                                  ${
                                    row.status == "purchased_partially_failed"
                                      ? "Purchased Partially Failed"
                                      : ""
                                  }
                                  ${row.status == "rejected" ? "Rejected" : ""}
              ${
                row.status == "partial_purchase" ? "Partial Purchased" : ""
              }                     </td>
        <td>${row.investor_name}</td>
        <td>${row.product_name}</td>
                <td>$${row.amount
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
        <td>$${
          row.cash_account == null
            ? 0.0
            : row.cash_account.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }</td>

      `;
      }
      body.appendChild(tr);
    });
    return body;
  }
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  const handleDownloadPDF = async () => {
    let columns = [];
    if (tab == "history" && isCurrentTab == "stock") {
      columns = [
        { label: "Code" },
        { label: "Purchase Date" },
        { label: "Purchase Time" },
        { label: "Quantity" },
        { label: "Price" },
        { label: "Broker Fee" },
        { label: "GST" },
        { label: "Total Cost" },
      ];
    } else if (tab == "orders") {
      columns = [
        { label: "Code" },
        { label: "Last/IAP" },
        { label: "+/-" },
        { label: "%" },
        { label: "Bid" },
        { label: "Ask" },
        { label: "Trades" },
        { label: "Volume" },
        { label: "Shares to be Purchased" },
        { label: "Shares to be Sold" },
        { label: "Individual Requests" },
      ];
    } else {
      columns = [
        { label: "Date" },
        { label: "Status" },
        { label: "Investor Name" },
        { label: "Product Name" },
        { label: "Investment Amount" },
        { label: "Cash Account" },
      ];
    }

    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody();
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
          @page {
    size: A4 landscape;
    margin: 0;
  }
    html, body {
            margin: 0;
            padding: 0;
                      font-family:sans-serif;
    overflow: auto;  /* Ensure content can overflow */
  
            height: 100%; /* Ensure the body fills the entire height */
          }        .pdf-container {
              max-width: 100% !important;
              margin: 20px;
            }
            tr {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
    
            .custom-header {
              position: relative;
              display: flex;
              justify-content: space-between;
              background-color: #ffffff;
              padding-top: 10px; /* Ensures no padding at the top */
            }
    
            .logo-container {
              display: flex;
              align-items: center;
            }
    
            .logo {
              width: 96px; /* Tailwind w-24 = 6rem = 96px */
              max-width: 150px;
              height: auto;
              object-fit: contain;
              margin-right: 1rem;
            }
    
            .title {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              font-size: 1.125rem; /* Tailwind text-lg */
              font-weight: 500;    /* Tailwind font-medium */
              padding: 0;          /* Remove any padding */
              margin: 0;           /* Remove any margin */
            }
    
            .date {
              font-size: 0.875rem;  /* Tailwind text-sm */
              font-weight: 500;
              color: #000000;
              padding-bottom: 16px;
            }
  
    
  .page-break {
           page-break-before: always;
    break-before: page;
    display: block;
    height: 0; /* No extra space */
    width: 100%;
    content: "";}
        table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
      }
  
      thead {
        font-size: 10px;
        color: #6B7280; /* Tailwind text-labelColour equivalent */
      }
  
      th {
        border-bottom: 1px solid #000;
        padding: 8px;
        text-align: left;
      }
            td {
        padding: 6px;
        font-size: 10px;
        vertical-align: middle;
        text-align: left;
      }
        .tbody-tr{
                    background-color: #F9F9F9;
                    margin-bottom: 10px;
  
        }
      .positive {
        color: #34C046;
      }
      .negative {
        color: #FF5050;
      }
      .description {
        text-align: left;
      }
          </style>
        </head>
        <body>
       <div class="pdf-container">
          <div class="custom-header">
            <div class="logo-container">
              <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Stock Purchases</h2>
            <div class="date">${date}</div>
          </div>
          
    <table id="dynamic-table">
    ${tableHeader}
      ${tableBody}
  
    </table>
      
        </div> 
  
             </body>
      </html>
    `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Stock Purchases-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (monthRef.current && !monthRef.current.contains(event.target)) {
        setMonthDropdown(false);
      }
      if (downloadRef.current && !downloadRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);
  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  function formatDateTime(inputDateStr) {
    const date = new Date(inputDateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const yyyy = date.getFullYear();

    const HH = String(date.getHours()).padStart(2, "0");
    const MM = String(date.getMinutes()).padStart(2, "0");
    const SS = String(date.getSeconds()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} | ${HH}:${MM}:${SS}`;
  }
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const handleSelect = (option) => {
    setSelected(option.label);
    setIsOpen(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const resetFilter = () => {
    setSearchQuery("");
    setCurrentPage(1);
    setSelectedRange("Select Date Range");
    setSelectedDates([]);
    setQuickFilter("");

    setOpenDropdown(null);
  };

  const UpdateInvestment = async (investmentId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investor_investment/stock-purchase/status/${investmentId}`;
    const bodyData = {
      status: "approved_for_purchase",
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleCreateInvestment = async (investment_id) => {
    try {
      const response = await UpdateInvestment(investment_id);
      if (response.status == 200) {
        getAll();
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const GetStockList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/stock-puchases/all?page=${currentPage}&sort_by=${filterText}&sort_order=${
              sortConfig.direction
            }&size=${showRecords}&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`
          : `${BASE_URL}/v1/investment-request/stock-puchases/all?page=${currentPage}&status=${filter}&sort_by=${filterText}&sort_order=${
              sortConfig.direction
            }&size=${showRecords}&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/stock-puchases/all?page=${currentPage}&sort_by=${filterText}&sort_order=${sortConfig.direction}&size=${showRecords}&search=${searchQuery}`
          : `${BASE_URL}/v1/investment-request/stock-puchases/all?page=${currentPage}&sort_by=${filterText}&sort_order=${sortConfig.direction}&status=${filter}&size=${showRecords}&search=${searchQuery}`;
    }
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const postLoginAPI = async () => {
    const token = localStorage.getItem("jwtToken");

    const apiUrl = `${BASE_URL}/v1/investment-request/execute/pending-orders`;
    const bodyData = {};
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const posttestingapi = async (url) => {
    const token = localStorage.getItem("jwtToken");

    const apiUrl = `${BASE_URL}${url}`;
    const bodyData = {};
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmitexecution = useCallback(
    debounce(async (e, firstCase) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postLoginAPI();
        if (response.status === 200) {
          getAllOrders();
          toastMessage = { message: "Execution sucessful", type: "success" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [] // Dependencies
  );
  const handleSubmitBellDirect = useCallback(
    debounce(async (e, firstCase) => {
      e.preventDefault();
      let toastMessage = null;
      let apiurl = "";
      try {
        if (firstCase == "1") {
          apiurl = "/v1/investment-request/check-bell-direct-orders";
        }
        if (firstCase == "2") {
          apiurl =
            "/v1/investment-request/check-bell-direct-orders?fill_status=3";
        }
        if (firstCase == "3") {
          apiurl =
            "/v1/investment-request/process-end-of-day-bell-direct-orders";
        }
        if (firstCase == "4") {
          apiurl = "/v1/investment-request/process-and-place-rollover-orders";
        }
        const response = await posttestingapi(apiurl);
        if (response.status === 200) {
          getAllOrders();
          toastMessage = { message: "Execution sucessful", type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [] // Dependencies
  );
  const GetInvestmentListForPdf = async () => {
    const token = localStorage.getItem("jwtToken");

    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/stock-puchases/all?sort_by=${filterText}&sort_order=${
              sortConfig.direction
            }&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`
          : `${BASE_URL}/v1/investment-request/stock-puchases/all?status=${filter}&sort_by=${filterText}&sort_order=${
              sortConfig.direction
            }&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/stock-puchases/all?sort_by=${filterText}&sort_order=${sortConfig.direction}&size=100&search=${searchQuery}`
          : `${BASE_URL}/v1/investment-request/stock-puchases/all?sort_by=${filterText}&sort_order=${sortConfig.direction}&status=${filter}&size=100&search=${searchQuery}`;
    }
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAll = async () => {
    try {
      const response = await GetStockList();

      if (response.status == 200) {
        setData(response.data.stock_purchases);
        setfilteredData(response.data.stock_purchases);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setfilteredData([]);
        console.log("I am wlslsk" + filteredData);
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  function convertToAmPm(time24) {
    const [hour, minute] = time24.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${period}`;
  }
  const UpdateSettings = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    // CUSTODY_FEE
    // ACCOUNT_KEEPING_FEE
    //MANAGEMENT_COST
    const apiUrl = `${BASE_URL}/v1/settings/bulk-update`;
    const bodyData = {
      settings: [
        {
          name: "ORDER_START_TIME",
          value: startTimeUpdate,
        },
        {
          name: "ORDER_END_TIME",
          value: endTimeUpdate,
        },
      ],
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateTransacion = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateSettings();
        if (response.status == 200) {
          togglePopupAddTransaction();
          getSettingsData();
          toastMessage = { message: "Updated successfully", type: "success" };
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [startTimeUpdate, endTimeUpdate] // Dependencies
  );
  const getSettingsData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/settings/all?fields=ORDER_START_TIME,ORDER_END_TIME`
      );
      if (response.status == 200) {
        const startTime = response.data.find(
          (item) => item.name === "ORDER_START_TIME"
        );
        setStartTime(convertToAmPm(startTime.value) || "");
        setStartTimeUpdate(startTime.value || "");

        const endTime = response.data.find(
          (item) => item.name === "ORDER_END_TIME"
        );
        setEndTime(convertToAmPm(endTime.value) || "");
        setEndTimeUpdate(endTime.value || "");
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];

  const handleSort = (key) => {
    setFilterText(key);
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: null, direction });
  };
  const GetStockOrders = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-request/confirmed-orders`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  function convertTimeFormat(timeStr) {
    let [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    // Convert to 10.30 format
    let formattedTime = `${hours}.${minutes}${modifier}`;

    return formattedTime;
  }
  function convertDateFormat(dateStr) {
    let [day, month, year] = dateStr.split("-").map(Number);

    // Convert to MM/DD/YYYY format
    return `${String(month).padStart(2, "0")}/${String(day).padStart(
      2,
      "0"
    )}/${year}`;
  }
  const GetstockHistory = async () => {
    const token = localStorage.getItem("jwtToken");
    let apiUrl = ``;

    if (selectedDates.length == 2) {
      apiUrl = `${BASE_URL}/v1/investment-request/purchase-history?start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl = `${BASE_URL}/v1/investment-request/purchase-history`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllOrders = async () => {
    setIsLoading(true);

    try {
      const response = await GetStockOrders();
      if (response.status == 200) {
        setStockOrderData(response.data);
        setPdfData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setStockOrderData([]);
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getpurchaseHistory = async () => {
    setIsLoading(true);

    try {
      const response = await GetstockHistory();

      if (response.status == 200) {
        setHistoryData(response.data);
        setPdfData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setHistoryData([]);
        setPdfData([]);
        showToast(response.message, "error");
      }
    } catch (err) {
      setHistoryData([]);
      setPdfData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  useEffect(() => {
    if (tab == "history" && isCurrentTab == "stock") {
      getpurchaseHistory();
    } else if (tab == "orders") {
      getAllOrders();
      getSettingsData();
    } else {
      getAll();
    }
  }, [
    filter,
    tab,
    showRecords,
    currentPage,
    status,
    filterText,
    sortConfig,
    selectedDates,
    changeStatus,
    searchQuery,
  ]);

  const headers = [
    { label: "Date", key: "created_at" },
    { label: "Status", key: "status" },
    { label: "Investor Name", key: "investor_name" },
    { label: "Product Name", key: "product_name" },
    { label: "Investment Amount", key: "amount" },
    { label: "Cash Account", key: "cash_account" },
    { label: "", key: "" }, // No sorting for actions
  ];
  const breakdownHeaders = [
    { label: "Date", key: "created_at" },
    { label: "Stock purchase", key: "Stock_purchase" },
    { label: "Broker fee", key: "investor_name" },
    { label: "Stock", key: "product_name" },
    { label: "Stock sale", key: "amount" },
  ];
  const handleScroll = (indexToRemove) => {
    console.log("I an scroll in document");
    setOpenDropdown(null);
  };

  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "10",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const togglePopupAddTransaction = () => setisOpenEdit(!isOpenEdit);

  return (
    <div className="">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="">
        <div className="pt-6 pr-4 flex-wrap overflow-x-auto items-center">
          <div className="flex text-sm mb-2">
            <button
              onClick={() => {
                setOpenDropdown(null);
                setFilter("");
                setTab("");
                resetFilter();
              }}
              className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                filter === "" ? "bg-black text-white" : "bg-white text-black"
              }`}
            >
              Active
            </button>
            <button
              onClick={() => {
                setFilter("orders");
                setTab("orders");
                setOpenDropdown(null);
                resetFilter();
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                tab === "orders" ? "bg-black text-white" : "bg-white text-black"
              }`}
            >
              Confirmed Orders
            </button>
            <button
              onClick={() => {
                setFilter("purchased");
                setTab("purchased");
                setOpenDropdown(null);
                resetFilter();
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                tab === "purchased"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Successful
            </button>
            <button
              onClick={() => {
                setFilter("partial_purchase");
                setTab("partial_purchase");
                setOpenDropdown(null);
                resetFilter();
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                tab === "partial_purchase"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Unsuccessful
            </button>{" "}
            <button
              onClick={() => {
                setFilter("rejected");
                setTab("rejected");
                setOpenDropdown(null);
                resetFilter();
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                tab === "rejected"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Rejected
            </button>
            <button
              onClick={() => {
                setFilter("hishghtory");
                setTab("history");
                setIsCurrentTab("stock");
                setOpenDropdown(null);
                resetFilter();
              }}
              className={`px-4 py-2 rounded-r-xl ${
                tab === "history"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Purchase History
            </button>
          </div>
        </div>
        {tab == "" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/stock-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-lg text-sm">
                  Stock Purchases
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-8 border rounded-xl"
                      placeholder="Search Requests"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {" "}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                <div
                  ref={DateCalendarRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative w-full">
                    {/* Dropdown Trigger */}
                    <div
                      className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <span>{selectedRange}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2"
                      />
                    </div>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                        <div className="flex  flex-col md:flex-row h-full">
                          {/* Left: Quick Filters */}
                          <div className="w-full md:w-1/3 border-r p-3 h-full">
                            {quickFilters.map((filter) => (
                              <div
                                key={filter.value}
                                className={`p-2 cursor-pointer rounded ${
                                  quickFilter === filter.value
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-200 text-black"
                                } transition-all duration-200 ease-in-out`}
                                onClick={() => handleQuickFilter(filter.value)}
                              >
                                {filter.label}
                              </div>
                            ))}
                          </div>

                          {/* Right: Calendar */}
                          <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                            <Flatpickr
                              key={selectedDates}
                              options={{
                                mode: "range",
                                inline: true,
                                dateFormat: "Y-m-d",
                                showMonths: 2,
                                defaultDate:
                                  selectedDates.length > 0 ? selectedDates : [],
                                shorthandCurrentMonth: true,
                                locale: {
                                  firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                },
                                onChange: (dates) => {
                                  if (
                                    quickFilter === "custom" &&
                                    dates.length === 2
                                  ) {
                                    setSelectedDates(dates);
                                  }
                                },
                              }}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div ref={downloadRef} className="relative inline-block ">
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <span className="text-gray-500">
                        {" "}
                        <img
                          src="/download-small-arrow.svg"
                          alt="Dropdown"
                          className="w-2 h-2"
                        />
                      </span>
                    </div>
                    {isOpen && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {options.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDF(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div onScroll={handleScroll} className="overflow-x-auto">
              <table className="w-full h-full border border-gray-200">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] text-sm">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header.label}
                        onClick={() => handleSort(header.key)}
                        className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                      >
                        {/* {header}
            <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                        <div class="flex items-center">
                          <span>{header.label}</span>
                          {header.label != "" && (
                            <img
                              src="/sort.svg"
                              alt="Icon"
                              class="w-4 h-4 ml-2"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(7)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm font-medium text-black">
                    {filteredData.length > 0 ? (
                      filteredData.map((row) => (
                        <tr className="mb-2 bg-[#F9F9F9]">
                          <td className="px-4 py-2">
                            {formatDateTime(row.date_created)}
                          </td>

                          {/* Dropdown Button */}
                          <td className="px-4 py-2  relative">
                            <button
                              disabled={true}
                              className={` w-40 text-left font-medium h-10 rounded-xl text-sm px-3 py-4  flex justify-between items-center focus:outline-none${
                                row.status == "pending"
                                  ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                  : ""
                              }
                              ${
                                row.status == "approved" ||
                                row.status == "approved_for_purchase" ||
                                row.status == "purchased"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                                  : ""
                              }
                              ${
                                row.status == "rejected" ||
                                row.status == "purchase_in_progress" ||
                                row.status == "purchased_partially_failed" ||
                                row.status == "partial_purchase"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                  : ""
                              }
                              `}
                            >
                              <span className="mr-6">
                                {" "}
                                {row.status == "pending" ? "Pending" : ""}
                                {row.status == "purchased" ? "Purchased" : ""}
                                {row.status == "approved_for_purchase"
                                  ? "Approved For Purchase"
                                  : ""}
                                {row.status == "purchase_in_progress"
                                  ? "Purchase In Progress"
                                  : ""}
                                {row.status == "purchased_partially_failed"
                                  ? "Purchased Partially Failed"
                                  : ""}
                                {row.status == "rejected" ? "Rejected" : ""}
                                {row.status == "partial_purchase"
                                  ? "Partial Purchased"
                                  : ""}
                              </span>
                            </button>
                          </td>

                          <td className=" px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                            {row.investor_name}
                          </td>
                          <td
                            onClick={(e) => {
                              e.preventDefault();

                              setCurrentInvestmentId(row.id);
                              setIsPopupOpenDetail(true);
                            }}
                            className="underline cursor-pointer px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight"
                          >
                            {row.product_name}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <span>
                              $
                              {row.amount
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-center">
                            $
                            {(row.cash_account == null ? 0 : row.cash_account)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>

                          <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                            {row.status == "pending" && (
                              <span
                                onClick={(e) => {
                                  e.preventDefault();

                                  setCurrentInvestmentId(row.id);
                                  setIsPopupOpen(true);
                                }}
                                className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                              >
                                Change Status
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center py-4" colSpan="7">
                          No results found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
            {isPopupOpenDetail && (
              <PortfolioBreakdownPopup
                currentInvestmentId={currentInvestmentId}
                isView={false}
                fromPartial={false}
                onClose={() => setIsPopupOpenDetail(false)}
              />
            )}
            {isPopupOpen && (
              <PortfolioBreakdownPopup
                setChangeStatus={setChangeStatus}
                isView={true}
                fromPartial={false}
                currentInvestmentId={currentInvestmentId}
                onClose={() => setIsPopupOpen(false)}
              />
            )}
            {!isLoading && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{" "}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.min(
                        showRecords * currentPage,
                        filteredData.length
                      )}{" "}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2)
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? "bg-black text-white"
                              : "bg-white border border-gray-300 text-black"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab == "orders" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 border-b pb-5 border-gray-100 space-y-4 lg:space-y-0">
              {/* Left Section */}
              <div className="flex items-center">
                <img
                  src="/stock-black.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6 lg:w-auto lg:h-auto"
                />
                <span className="font-medium text-base lg:text-lg">
                  Stock Purchases
                </span>
              </div>

              {/* Right Section */}
              <div className="flex justify-between lg:justify-end items-center space-x-4 w-full lg:w-auto">
                <div
                  ref={downloadRef}
                  className="relative inline-block w-full lg:w-auto"
                >
                  <div
                    className="flex justify-between items-center p-3 border border-gray-200 h-11 w-full lg:w-60 rounded-xl cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <img
                      src="/document-download.svg"
                      alt="document-download"
                      className="mr-2 w-5 h-5 lg:w-auto lg:h-auto"
                    />
                    <span className="truncate">{selected}</span>
                    <span className="text-gray-500">
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-3 h-3"
                      />
                    </span>
                  </div>
                  {isOpen && (
                    <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                      {options.map((option) => (
                        <li
                          key={option.value}
                          className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            setLoading(true);
                            downloadPDF(e, option);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0"></div>
            </div>

            {/* Table */}

            <div className="overflow-x-auto max-h-[80vh]  overflow-y-auto ">
              <table className="table-auto border-collapse font-medium w-full text-xs">
                <thead>
                  <tr className="bg-[#ECFFEE] text-[#005A9C]">
                    <th className="border  text-left px-4 py-2">Code</th>
                    <th className="border text-left px-4 py-2">Last/IAP</th>
                    <th className="border text-left px-4 py-2">+/-</th>
                    <th className="border text-left px-4 py-2">%</th>
                    <th className="border text-left px-4 py-2">Bid</th>
                    <th className="border text-left px-4 py-2">Ask</th>
                    <th className="border text-left px-4 py-2">Trades</th>
                    <th className="border text-left px-4 py-2">Volume</th>
                    <th className="border text-left px-4 py-2">
                      Shares to be Purchased
                    </th>
                    <th className="border text-left px-4 py-2">
                      Shares to be Sold
                    </th>
                    <th className="border text-left px-4 py-2">
                      Individual Requests
                    </th>
                    <th className="border text-left px-4 py-2">View</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    {stockOrderData.map((row, index) => (
                      <tr key={index} className={`text-[#black]`}>
                        <td className="border bg-[#ECFAFF] px-4 py-2">
                          {row.code}
                        </td>
                        <td className="border px-4 py-2">
                          {row.last_iap >= 0 ? "$" : "-$"}
                          {Math.abs(row.last_iap.toFixed(2))}
                        </td>
                        <td className="border px-4 py-2">
                          {row.change >= 0 ? "$" : "-$"}
                          {Math.abs(row.change.toFixed(2))}
                        </td>
                        <td className="border px-4 py-2">${row.bid}</td>
                        <td className="border px-4 py-2">${row.ask}</td>
                        <td className="border px-4 py-2">${row.vwap}</td>
                        <td className="border px-4 py-2">${row.trades}</td>
                        <td className="border px-4 py-2">${row.volume}</td>
                        <td className="border px-4 py-2 bg-[#FDF4FF]">
                          {row.shares_to_be_purshaed}
                        </td>
                        <td className="border px-4 py-2 bg-[#FDF4FF]">
                          {row.shares_to_be_sold}
                        </td>
                        <td className="border px-4 py-2 bg-[#FDF4FF]">
                          {row.total_requests}
                        </td>
                        <td className="border px-4 py-2">
                          <span
                            onClick={(e) => {
                              e.preventDefault();

                              setCurrentData(row);
                              setisPopupBreakdownOpen(true);
                            }}
                            className={`w-30 h-8 cursor-pointer rounded-xl text-center px-4 py-2 flex justify-center items-center focus:outline-none border-2 border-black text-black`}
                          >
                            Breakdown
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            {isPopupBreakdownOpen && (
              <StockBreakdownPopup
                currentStockId={currentdata}
                fromHistory={false}
                onClose={() => setisPopupBreakdownOpen(false)}
              />
            )}
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start mt-6 p-4 space-y-4 lg:space-y-0 lg:space-x-4">
              {/* Left Section: Back Button */}
              <div className="flex items-center justify-start space-x-2 text-sm md:text-md font-medium py-1 px-0 cursor-pointer">
                <span>
                  Orders will be executed in between{" "}
                  <span className="font-bold">
                    {startTime}-{endTime}
                  </span>
                </span>
              </div>

              {/* Right Section: Change Execution Time Button */}
              <div className="flex items-center justify-start">
                <button
                  onClick={togglePopupAddTransaction}
                  className="flex items-center space-x-2 bg-white border-2 border-black text-black font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Change Execution Time</span>
                </button>
              </div>

              {/* Right Section: Pause Execution Button */}
              <div className="flex items-center justify-start">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSubmitexecution(e);
                  }}
                  className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 rounded-full text-sm"
                >
                  <span>Execute Order</span>
                </button>
              </div>
            </div>
            {isOpenEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 h-[90vh] md:h-auto max-h-screen overflow-y-auto">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Transaction Execution Time
                    </h2>
                    <button onClick={togglePopupAddTransaction}>
                      <img src="/add.svg" alt="Close" className="w-10 h-10" />
                    </button>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="dcredit"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Start Time
                      </label>
                      <input
                        type="time"
                        name="startTime"
                        value={startTimeUpdate}
                        onChange={(e) => setStartTimeUpdate(e.target.value)}
                        className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    {/* center column */}
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0  md:border-l border-gray-300 px-4">
                      <label
                        htmlFor="dcredit"
                        className="mb-1 text-sm text-labelColour"
                      >
                        End Time
                      </label>
                      <input
                        type="time"
                        name="endTime"
                        value={endTimeUpdate}
                        onChange={(e) => setEndTimeUpdate(e.target.value)}
                        className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                  </div>
                  {/* Modal Footer */}
                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      onClick={togglePopupAddTransaction}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();

                        setLoading(true);
                        handleUpdateTransacion(e);
                      }}
                      className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start mt-2 p-4 space-y-4 lg:space-y-0 lg:space-x-4">
              {/* Right Section: Pause Execution Button */}
              <div className="flex items-center justify-start lg:space-x-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSubmitBellDirect(e, "1");
                  }}
                  className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 rounded-full text-sm"
                >
                  <span>Partial fill</span>
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSubmitBellDirect(e, "2");
                  }}
                  className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 rounded-full text-sm"
                >
                  <span>Compeltely fill</span>
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSubmitBellDirect(e, "3");
                  }}
                  className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 rounded-full text-sm"
                >
                  <span>⁠End Trading Day</span>
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleSubmitBellDirect(e, "4");
                  }}
                  className="flex items-center space-x-2 bg-black text-white font-medium py-2 px-6 rounded-full text-sm"
                >
                  <span>⁠Create Previous Days Order</span>
                </button>
              </div>
            </div>
          </div>
        )}
        {filter == "purchased" && tab != "history" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/stock-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-lg text-sm">
                  Stock Purchases
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-8 border rounded-xl"
                      placeholder="Search Requests"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {" "}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                <div
                  ref={DateCalendarRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative w-full">
                    {/* Dropdown Trigger */}
                    <div
                      className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <span>{selectedRange}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2"
                      />
                    </div>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                        <div className="flex  flex-col md:flex-row h-full">
                          {/* Left: Quick Filters */}
                          <div className="w-full md:w-1/3 border-r p-3 h-full">
                            {quickFilters.map((filter) => (
                              <div
                                key={filter.value}
                                className={`p-2 cursor-pointer rounded ${
                                  quickFilter === filter.value
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-200 text-black"
                                } transition-all duration-200 ease-in-out`}
                                onClick={() => handleQuickFilter(filter.value)}
                              >
                                {filter.label}
                              </div>
                            ))}
                          </div>

                          {/* Right: Calendar */}
                          <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                            <Flatpickr
                              key={selectedDates}
                              options={{
                                mode: "range",
                                inline: true,
                                dateFormat: "Y-m-d",
                                showMonths: 2,
                                defaultDate:
                                  selectedDates.length > 0 ? selectedDates : [],
                                shorthandCurrentMonth: true,
                                locale: {
                                  firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                },
                                onChange: (dates) => {
                                  if (
                                    quickFilter === "custom" &&
                                    dates.length === 2
                                  ) {
                                    setSelectedDates(dates);
                                  }
                                },
                              }}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div ref={downloadRef} className="relative inline-block ">
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <span className="text-gray-500">
                        {" "}
                        <img
                          src="/download-small-arrow.svg"
                          alt="Dropdown"
                          className="w-2 h-2"
                        />
                      </span>
                    </div>
                    {isOpen && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {options.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDF(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div onScroll={handleScroll} className="overflow-x-auto">
              <table className="w-full h-full border border-gray-200">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] text-sm">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header.label}
                        onClick={() => handleSort(header.key)}
                        className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                      >
                        {/* {header}
       <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                        <div class="flex items-center">
                          <span>{header.label}</span>
                          {header.label != "" && (
                            <img
                              src="/sort.svg"
                              alt="Icon"
                              class="w-4 h-4 ml-2"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(7)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm font-medium text-black">
                    {filteredData.length > 0 ? (
                      filteredData.map((row) => (
                        <tr className="mb-2 bg-[#F9F9F9]">
                          <td className="px-4 py-2">
                            {formatDateTime(row.date_created)}
                          </td>

                          {/* Dropdown Button */}
                          <td className="px-4 py-2 relative">
                            <button
                              disabled={true}
                              className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                row.status == "pending"
                                  ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                  : ""
                              }
                         ${
                           row.status == "approved" ||
                           row.status == "approved_for_purchase" ||
                           row.status == "purchased"
                             ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                             : ""
                         }
                         ${
                           row.status == "rejected" ||
                           row.status == "purchase_in_progress" ||
                           row.status == "purchased_partially_failed" ||
                           row.status == "partial_purchase"
                             ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                             : ""
                         }
                         `}
                            >
                              <span className="mr-6">
                                {" "}
                                {row.status == "pending" ? "Pending" : ""}
                                {row.status == "purchased" ? "Purchased" : ""}
                                {row.status == "approved_for_purchase"
                                  ? "Approved For Purchase"
                                  : ""}
                                {row.status == "purchase_in_progress"
                                  ? "Purchase In Progress"
                                  : ""}
                                {row.status == "purchased_partially_failed"
                                  ? "Purchased Partially Failed"
                                  : ""}
                                {row.status == "rejected" ? "Rejected" : ""}
                                {row.status == "partial_purchase"
                                  ? "Partial Purchased"
                                  : ""}
                              </span>
                            </button>
                          </td>

                          <td className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                            {row.investor_name}
                          </td>
                          <td className="px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                            {row.product_name}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <span>
                              $
                              {row.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-center">
                            $
                            {row.cash_account == null
                              ? 0.0
                              : row.cash_account
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>

                          <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentInvestmentId(row.id);
                                setIsPopupOpen(true);
                              }}
                              className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                            >
                              View Breakdown
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center py-4" colSpan="7">
                          No results found
                        </td>
                      </tr>
                    )}
                    {isPopupOpen && (
                      <PortfolioBreakdownPopup
                        setChangeStatus={setChangeStatus}
                        isView={false}
                        fromPartial={false}
                        currentInvestmentId={currentInvestmentId}
                        onClose={() => setIsPopupOpen(false)}
                      />
                    )}
                  </tbody>
                )}
              </table>
            </div>
            {!isLoading && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{" "}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.min(
                        showRecords * currentPage,
                        filteredData.length
                      )}{" "}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2)
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? "bg-black text-white"
                              : "bg-white border border-gray-300 text-black"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {filter == "partial_purchase" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/stock-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-lg text-sm">
                  Stock Purchases
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-8 border rounded-xl"
                      placeholder="Search Requests"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {" "}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                <div
                  ref={DateCalendarRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative w-full">
                    {/* Dropdown Trigger */}
                    <div
                      className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <span>{selectedRange}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2"
                      />
                    </div>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                        <div className="flex  flex-col md:flex-row h-full">
                          {/* Left: Quick Filters */}
                          <div className="w-full md:w-1/3 border-r p-3 h-full">
                            {quickFilters.map((filter) => (
                              <div
                                key={filter.value}
                                className={`p-2 cursor-pointer rounded ${
                                  quickFilter === filter.value
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-200 text-black"
                                } transition-all duration-200 ease-in-out`}
                                onClick={() => handleQuickFilter(filter.value)}
                              >
                                {filter.label}
                              </div>
                            ))}
                          </div>

                          {/* Right: Calendar */}
                          <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                            <Flatpickr
                              key={selectedDates}
                              options={{
                                mode: "range",
                                inline: true,
                                dateFormat: "Y-m-d",
                                showMonths: 2,
                                defaultDate:
                                  selectedDates.length > 0 ? selectedDates : [],
                                shorthandCurrentMonth: true,
                                locale: {
                                  firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                },
                                onChange: (dates) => {
                                  if (
                                    quickFilter === "custom" &&
                                    dates.length === 2
                                  ) {
                                    setSelectedDates(dates);
                                  }
                                },
                              }}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div ref={downloadRef} className="relative inline-block ">
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <span className="text-gray-500">
                        {" "}
                        <img
                          src="/download-small-arrow.svg"
                          alt="Dropdown"
                          className="w-2 h-2"
                        />
                      </span>
                    </div>
                    {isOpen && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {options.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDF(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div onScroll={handleScroll} className="overflow-x-auto">
              <table className="w-full h-full border border-gray-200">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] text-sm">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header.label}
                        onClick={() => handleSort(header.key)}
                        className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                      >
                        <div class="flex items-center">
                          <span>{header.label}</span>
                          {header.label != "" && (
                            <img
                              src="/sort.svg"
                              alt="Icon"
                              class="w-4 h-4 ml-2"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(7)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm font-medium text-black">
                    {filteredData.length > 0 ? (
                      filteredData.map((row) => (
                        <tr className="mb-2 bg-[#F9F9F9]">
                          <td className="px-4 py-2">
                            {formatDateTime(row.date_created)}
                          </td>

                          {/* Dropdown Button */}
                          <td className="px-4 py-2 relative">
                            <button
                              disabled={true}
                              className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                row.status == "pending"
                                  ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                  : ""
                              }
                         ${
                           row.status == "approved" ||
                           row.status == "approved_for_purchase" ||
                           row.status == "purchased"
                             ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                             : ""
                         }
                         ${
                           row.status == "rejected" ||
                           row.status == "purchase_in_progress" ||
                           row.status == "purchased_partially_failed" ||
                           row.status == "partial_purchase"
                             ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                             : ""
                         }
                         `}
                            >
                              <span className="mr-6">
                                {" "}
                                {row.status == "pending" ? "Pending" : ""}
                                {row.status == "purchased" ? "Purchased" : ""}
                                {row.status == "approved_for_purchase"
                                  ? "Approved For Purchase"
                                  : ""}
                                {row.status == "purchase_in_progress"
                                  ? "Purchase In Progress"
                                  : ""}
                                {row.status == "purchased_partially_failed"
                                  ? "Purchased Partially Failed"
                                  : ""}
                                {row.status == "rejected" ? "Rejected" : ""}
                                {row.status == "partial_purchase"
                                  ? "Partial Purchased"
                                  : ""}
                              </span>
                            </button>
                          </td>

                          <td className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                            {row.investor_name}
                          </td>
                          <td className="px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                            {row.product_name}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <span>
                              $
                              {row.amount
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-center">
                            $
                            {(row.cash_account == null ? 0 : row.cash_account)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>

                          <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                            <span
                              onClick={(e) => {
                                e.preventDefault();

                                setCurrentInvestmentId(row.id);
                                setIsPopupOpen(true);
                              }}
                              className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                            >
                              View Breakdown
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center py-4" colSpan="7">
                          No results found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
                {isPopupOpen && (
                  <PortfolioBreakdownPopup
                    currentInvestmentId={currentInvestmentId}
                    isView={false}
                    fromPartial={true}
                    onClose={() => setIsPopupOpen(false)}
                  />
                )}
              </table>
            </div>
            {!isLoading && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{" "}
                  {currentPage === totalPages
                    ? totalCount
                    : Math.min(
                        showRecords * currentPage,
                        filteredData.length
                      )}{" "}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2)
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? "bg-black text-white"
                              : "bg-white border border-gray-300 text-black"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {filter == "rejected" && (
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/stock-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-lg text-sm">
                  Stock Purchases
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-8 border rounded-xl"
                      placeholder="Search Requests"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {" "}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                <div
                  ref={DateCalendarRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative w-full">
                    {/* Dropdown Trigger */}
                    <div
                      className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <span>{selectedRange}</span>
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2"
                      />
                    </div>

                    {/* Dropdown */}
                    {isDropdownOpen && (
                      <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                        <div className="flex  flex-col md:flex-row h-full">
                          {/* Left: Quick Filters */}
                          <div className="w-full md:w-1/3 border-r p-3 h-full">
                            {quickFilters.map((filter) => (
                              <div
                                key={filter.value}
                                className={`p-2 cursor-pointer rounded ${
                                  quickFilter === filter.value
                                    ? "bg-black text-white"
                                    : "hover:bg-gray-200 text-black"
                                } transition-all duration-200 ease-in-out`}
                                onClick={() => handleQuickFilter(filter.value)}
                              >
                                {filter.label}
                              </div>
                            ))}
                          </div>

                          {/* Right: Calendar */}
                          <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                            <Flatpickr
                              key={selectedDates}
                              options={{
                                mode: "range",
                                inline: true,
                                dateFormat: "Y-m-d",
                                showMonths: 2,
                                defaultDate:
                                  selectedDates.length > 0 ? selectedDates : [],
                                shorthandCurrentMonth: true,
                                locale: {
                                  firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                },
                                onChange: (dates) => {
                                  if (
                                    quickFilter === "custom" &&
                                    dates.length === 2
                                  ) {
                                    setSelectedDates(dates);
                                  }
                                },
                              }}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div ref={downloadRef} className="relative inline-block ">
                    <div
                      className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <img
                        src="/document-download.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>{selected}</span>
                      <span className="text-gray-500">
                        {" "}
                        <img
                          src="/download-small-arrow.svg"
                          alt="Dropdown"
                          className="w-2 h-2"
                        />
                      </span>
                    </div>
                    {isOpen && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {options.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              downloadPDF(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div onScroll={handleScroll} className="overflow-x-auto">
              <table className="w-full h-full border border-gray-200">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] text-sm">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header.label}
                        onClick={() => handleSort(header.key)}
                        className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                      >
                        {/* {header}
       <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                        <div class="flex items-center">
                          <span>{header.label}</span>
                          {header.label != "" && (
                            <img
                              src="/sort.svg"
                              alt="Icon"
                              class="w-4 h-4 ml-2"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(7)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm font-medium text-black">
                    {filteredData.length > 0 ? (
                      filteredData.map((row) => (
                        <tr className="mb-2 bg-[#F9F9F9]">
                          <td className="px-4 py-2">
                            {formatDateTime(row.date_created)}
                          </td>

                          {/* Dropdown Button */}
                          <td className="px-4 py-2 relative">
                            <button
                              disabled={true}
                              className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                row.status == "pending"
                                  ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                  : ""
                              }
                         ${
                           row.status == "approved" ||
                           row.status == "approved_for_purchase" ||
                           row.status == "purchased"
                             ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                             : ""
                         }
                         ${
                           row.status == "rejected" ||
                           row.status == "purchase_in_progress" ||
                           row.status == "purchased_partially_failed" ||
                           row.status == "partial_purchase"
                             ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                             : ""
                         }
                         `}
                            >
                              <span className="mr-6">
                                {" "}
                                {row.status == "pending" ? "Pending" : ""}
                                {row.status == "purchased" ? "Purchased" : ""}
                                {row.status == "approved_for_purchase"
                                  ? "Approved For Purchase"
                                  : ""}
                                {row.status == "purchase_in_progress"
                                  ? "Purchase In Progress"
                                  : ""}
                                {row.status == "purchased_partially_failed"
                                  ? "Purchased Partially Failed"
                                  : ""}
                                {row.status == "rejected" ? "Rejected" : ""}
                                {row.status == "partial_purchase"
                                  ? "Partial Purchased"
                                  : ""}
                              </span>
                            </button>
                          </td>

                          <td className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                            {row.investor_name}
                          </td>
                          <td className="px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                            {row.product_name}
                          </td>
                          <td className="px-4 py-2 text-center">
                            <span>
                              $
                              {row.amount
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-center">
                            $
                            {(row.cash_account == null ? 0 : row.cash_account)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>

                          <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                            <span
                              onClick={(e) => {
                                e.preventDefault();

                                setCurrentInvestmentId(row.id);
                                setIsPopupOpen(true);
                              }}
                              className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                            >
                              View Breakdown
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center py-4" colSpan="7">
                          No results found
                        </td>
                      </tr>
                    )}
                    {isPopupOpen && (
                      <PortfolioBreakdownPopup
                        currentInvestmentId={currentInvestmentId}
                        isView={false}
                        fromPartial={false}
                        onClose={() => setIsPopupOpen(false)}
                      />
                    )}
                  </tbody>
                )}
              </table>
            </div>
            {!isLoading && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{" "}
                  {currentPage === totalPages
                    ? totalCount
                    : Math.min(
                        showRecords * currentPage,
                        filteredData.length
                      )}{" "}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2)
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? "bg-black text-white"
                              : "bg-white border border-gray-300 text-black"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab == "history" && (
          <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
            {/* Top Navigation */}
            <div className="bg-white p-6 shadow rounded-lg ">
              <div className="flex flex-wrap items-center space-x-0 md:space-x-4 mb-6">
                {/* Stock Purchases Tab */}
                <span
                  onClick={() => setIsCurrentTab("stock")}
                  className={`cursor-pointer pr-4 font-medium ${
                    isCurrentTab === "stock"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                >
                  Stock Purchases
                </span>
                <span className="text-[#B2B2B2] hidden md:inline">|</span>

                {/* Portfolio Purchases Tab */}
                <span
                  onClick={() => {
                    setIsCurrentTab("portfolio");
                    setFilter("purchased");
                  }}
                  className={`cursor-pointer pr-4 font-medium ${
                    isCurrentTab === "portfolio"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                >
                  Portfolio Purchases
                </span>
                {/* Uncomment it if will be needed in the future */}
                {/* <span className="text-[#B2B2B2] hidden md:inline">|</span>

                <span
                  onClick={() => setIsCurrentTab("breakdown")}
                  className={`cursor-pointer pr-4 font-medium ${
                    isCurrentTab === "breakdown"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                >
                  Purchase Breakdown
                </span> */}
              </div>

              {isCurrentTab == "stock" && (
                <div className="p-2 mb-4">
                  <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div
                      ref={DateCalendarRef}
                      className="flex items-center space-x-4"
                    >
                      <div className="relative w-full">
                        {/* Dropdown Trigger */}
                        <div
                          className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                          onClick={toggleDropdown}
                        >
                          <span>{selectedRange}</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2"
                          />
                        </div>

                        {/* Dropdown */}
                        {isDropdownOpen && (
                          <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                            <div className="flex  flex-col md:flex-row h-full">
                              {/* Left: Quick Filters */}
                              <div className="w-full md:w-1/3 border-r p-3 h-full">
                                {quickFilters.map((filter) => (
                                  <div
                                    key={filter.value}
                                    className={`p-2 cursor-pointer rounded ${
                                      quickFilter === filter.value
                                        ? "bg-black text-white"
                                        : "hover:bg-gray-200 text-black"
                                    } transition-all duration-200 ease-in-out`}
                                    onClick={() =>
                                      handleQuickFilter(filter.value)
                                    }
                                  >
                                    {filter.label}
                                  </div>
                                ))}
                              </div>

                              {/* Right: Calendar */}
                              <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                <Flatpickr
                                  key={selectedDates}
                                  options={{
                                    mode: "range",
                                    inline: true,
                                    dateFormat: "Y-m-d",
                                    showMonths: 2,
                                    defaultDate:
                                      selectedDates.length > 0
                                        ? selectedDates
                                        : [],
                                    shorthandCurrentMonth: true,
                                    locale: {
                                      firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                    },
                                    onChange: (dates) => {
                                      if (
                                        quickFilter === "custom" &&
                                        dates.length === 2
                                      ) {
                                        setSelectedDates(dates);
                                      }
                                    },
                                  }}
                                  className="w-full"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div ref={downloadRef} className="relative inline-block ">
                        <div
                          className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <span className="text-gray-500">
                            {" "}
                            <img
                              src="/download-small-arrow.svg"
                              alt="Dropdown"
                              className="w-2 h-2"
                            />
                          </span>
                        </div>
                        {isOpen && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                            {options.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDF(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto max-h-[80vh]  overflow-y-auto ">
                    <table className="table-auto border-collapse font-medium w-full text-xs">
                      <thead>
                        <tr className="bg-[#ECFFEE] text-[#005A9C]">
                          <th className="border  text-left px-4 py-2">Code</th>
                          <th className="border text-left px-4 py-2">
                            Purchase Date
                          </th>
                          <th className="border text-left px-4 py-2">
                            Purchase Time
                          </th>
                          <th className="border text-left px-4 py-2">
                            Quantity
                          </th>
                          <th className="border text-left px-4 py-2">Price</th>
                          <th className="border text-left px-4 py-2">
                            Broker Fee
                          </th>
                          <th className="border text-left px-4 py-2">GST</th>
                          <th className="border text-left px-4 py-2">
                            Total Cost
                          </th>
                          <th className="border text-left px-4 py-2">Action</th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(10)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          {historyData.length > 0 ? (
                            historyData.map((row, index) => (
                              <tr key={index} className={`text-[#black]`}>
                                <td className="border bg-[#ECFAFF] px-4 py-2">
                                  {row.code}
                                </td>
                                <td className="border px-4 py-2">
                                  {" "}
                                  {convertDateFormat(row.date)}
                                </td>
                                <td className="border px-4 py-2">
                                  {convertTimeFormat(row.purchase_time)}
                                </td>
                                <td className="border px-4 py-2">
                                  {row.quantity}
                                </td>
                                <td className="border px-4 py-2">
                                  ${row.price.toFixed(2)}
                                </td>
                                <td className="border px-4 py-2">
                                  ${row.broker_fee.toFixed(2)}
                                </td>
                                <td className="border px-4 py-2">${row.gst}</td>
                                <td className="border px-4 py-2">
                                  {row.total_cost
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td className="border px-4 py-2">
                                  <span
                                    onClick={(e) => {
                                      e.preventDefault();

                                      setCurrentData(row);
                                      setisPopupBreakdownOpen(true);
                                    }}
                                    className={`w-30 h-8 cursor-pointer rounded-xl text-center px-4 py-2 flex justify-center items-center focus:outline-none border-2 border-black text-black`}
                                  >
                                    Breakdown
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {isPopupBreakdownOpen && (
                    <StockBreakdownPopup
                      currentStockId={currentdata}
                      fromHistory={true}
                      onClose={() => setisPopupBreakdownOpen(false)}
                    />
                  )}
                </div>
              )}
              {isCurrentTab == "portfolio" && (
                <div className="p-2 mb-4">
                  <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleFilterChange}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <input
                            type="text"
                            className="p-2 pl-8 border rounded-xl"
                            placeholder="Search Requests"
                            value={searchQuery}
                            onChange={(e) => {
                              setCurrentPage(1);
                              setSearchQuery(e.target.value);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.svg"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4 flex  flex-col md:flex-row ">
                      <div
                        ref={DateCalendarRef}
                        className="flex items-center  w-full space-x-4"
                      >
                        <div className="relative w-full">
                          {/* Dropdown Trigger */}
                          <div
                            className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                            onClick={toggleDropdown}
                          >
                            <span>{selectedRange}</span>
                            <img
                              src="/download-small-arrow.svg"
                              alt="Dropdown"
                              className="w-2 h-2"
                            />
                          </div>

                          {/* Dropdown */}
                          {isDropdownOpen && (
                            <div className="absolute top-12 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                              <div className="flex  flex-col md:flex-row h-full">
                                {/* Left: Quick Filters */}
                                <div className="w-full md:w-1/3 border-r p-3 h-full">
                                  {quickFilters.map((filter) => (
                                    <div
                                      key={filter.value}
                                      className={`p-2 cursor-pointer rounded ${
                                        quickFilter === filter.value
                                          ? "bg-black text-white"
                                          : "hover:bg-gray-200 text-black"
                                      } transition-all duration-200 ease-in-out`}
                                      onClick={() =>
                                        handleQuickFilter(filter.value)
                                      }
                                    >
                                      {filter.label}
                                    </div>
                                  ))}
                                </div>

                                {/* Right: Calendar */}
                                <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                                  <Flatpickr
                                    key={selectedDates}
                                    options={{
                                      mode: "range",
                                      inline: true,
                                      dateFormat: "Y-m-d",
                                      showMonths: 2,
                                      defaultDate:
                                        selectedDates.length > 0
                                          ? selectedDates
                                          : [],
                                      shorthandCurrentMonth: true,
                                      locale: {
                                        firstDayOfWeek: 1, // Sets Monday as the first day of the week
                                      },
                                      onChange: (dates) => {
                                        if (
                                          quickFilter === "custom" &&
                                          dates.length === 2
                                        ) {
                                          setSelectedDates(dates);
                                        }
                                      },
                                    }}
                                    className="w-full"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="relative  w-full inline-block ">
                        <div
                          ref={downloadRef}
                          className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <span className="text-gray-500">
                            {" "}
                            <img
                              src="/download-small-arrow.svg"
                              alt="Dropdown"
                              className="w-2 h-2"
                            />
                          </span>
                        </div>
                        {isOpen && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                            {options.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDF(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  <div onScroll={handleScroll} className="overflow-x-auto">
                    <table className="w-full h-full border border-gray-200">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr>
                          {headers.map((header) => (
                            <th
                              key={header.label}
                              onClick={() => handleSort(header.key)}
                              className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                            >
                              {/* {header}
            <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                              <div class="flex items-center">
                                <span>{header.label}</span>
                                {header.label != "" && (
                                  <img
                                    src="/sort.svg"
                                    alt="Icon"
                                    class="w-4 h-4 ml-2"
                                  />
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(7)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {filteredData.length > 0 ? (
                            filteredData.map((row) => (
                              <tr className="mb-2 bg-[#F9F9F9]">
                                <td className="px-4 py-2">
                                  {formatDateTime(row.date_created)}
                                </td>

                                {/* Dropdown Button */}
                                <td className="px-4 py-2  relative">
                                  <button
                                    disabled={true}
                                    className={` w-40 text-left font-medium h-10 rounded-xl text-sm px-3 py-4  flex justify-between items-center focus:outline-none${
                                      row.status == "pending"
                                        ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                        : ""
                                    }
                              ${
                                row.status == "approved" ||
                                row.status == "approved_for_purchase" ||
                                row.status == "purchased"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                                  : ""
                              }
                              ${
                                row.status == "rejected" ||
                                row.status == "purchase_in_progress" ||
                                row.status == "purchased_partially_failed" ||
                                row.status == "partial_purchase"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                  : ""
                              }
                              `}
                                  >
                                    <span className="mr-6">
                                      {" "}
                                      {row.status == "pending" ? "Pending" : ""}
                                      {row.status == "purchased"
                                        ? "Purchased"
                                        : ""}
                                      {row.status == "approved_for_purchase"
                                        ? "Approved For Purchase"
                                        : ""}
                                      {row.status == "purchase_in_progress"
                                        ? "Purchase In Progress"
                                        : ""}
                                      {row.status ==
                                      "purchased_partially_failed"
                                        ? "Purchased Partially Failed"
                                        : ""}
                                      {row.status == "rejected"
                                        ? "Rejected"
                                        : ""}
                                      {row.status == "partial_purchase"
                                        ? "Partial Purchased"
                                        : ""}
                                    </span>
                                  </button>
                                </td>

                                <td className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                  {row.investor_name}
                                </td>
                                <td
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentInvestmentId(row.id);
                                    setIsPopupOpenDetail(true);
                                  }}
                                  className="underline cursor-pointer px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight"
                                >
                                  {row.product_name}
                                </td>
                                <td className="px-4 py-2 text-center">
                                  <span>
                                    $
                                    {row.amount
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </td>
                                <td className="px-4 py-2 text-center">
                                  $
                                  {(row.cash_account == null
                                    ? 0
                                    : row.cash_account
                                  )
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                                  {row.status == "pending" && (
                                    <span
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCurrentInvestmentId(row.id);
                                        setIsPopupOpen(true);
                                      }}
                                      className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                                    >
                                      Change Status
                                    </span>
                                  )}
                                </td>
                                {isPopupOpen && (
                                  <PortfolioBreakdownPopup
                                    fromPartial={false}
                                    currentInvestmentId={currentInvestmentId}
                                    onClose={() => setIsPopupOpen(false)}
                                  />
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                      {isPopupOpenDetail && (
                        <PortfolioBreakdownPopup
                          currentInvestmentId={currentInvestmentId}
                          isView={false}
                          fromPartial={false}
                          onClose={() => setIsPopupOpenDetail(false)}
                        />
                      )}
                    </table>
                  </div>
                  {!isLoading && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages
                          ? totalCount
                          : Math.min(
                              showRecords * currentPage,
                              filteredData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}

                        {/* Next Button */}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Input Section */}
              {isCurrentTab === "breakdown" && (
                <div className="p-4 mb-6 bg-white border rounded-lg shadow-sm">
                  {/* Header Section */}
                  <div className="flex flex-col md:flex-row md:justify-end md:items-center border-b pb-4 mb-4">
                    <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-4">
                      {/* Dropdown Menu */}
                      <div
                        className="relative group w-full md:w-auto"
                        ref={monthRef}
                      >
                        <button
                          onClick={() => setMonthDropdown(!isMonthOpen)}
                          className={`flex justify-between items-center border px-4 py-2 rounded-lg w-full md:w-auto ${
                            isMonthOpen ? "border-black border-2" : ""
                          }`}
                        >
                          <span className="mr-2">2021 April</span>
                          <img
                            src="/download-small-arrow.svg"
                            alt="Dropdown"
                            className="w-2 h-2"
                          />
                        </button>
                        {/* Dropdown Options */}
                        {isMonthOpen && (
                          <div className="absolute mt-2 bg-white border border-gray-300 rounded-lg shadow-lg flex z-10 w-full md:w-[300px]">
                            {/* Year Column */}
                            <ul className="flex-1 border-r border-gray-300">
                              {["2021", "2022", "2023", "2024", "2025"].map(
                                (year) => (
                                  <li
                                    key={year}
                                    className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer"
                                  >
                                    {year}
                                  </li>
                                )
                              )}
                            </ul>
                            {/* Month Column */}
                            <ul className="flex-1">
                              {[
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December",
                              ].map((month) => (
                                <li
                                  key={month}
                                  className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer"
                                >
                                  {month}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      {/* Download Report Button */}
                      <div
                        className="relative inline-block w-full md:w-auto"
                        ref={downloadRef}
                      >
                        <div
                          className={`flex justify-between items-center p-3 border h-11 w-full md:w-60 rounded-xl cursor-pointer ${
                            isOpen ? "border-black border-2" : ""
                          }`}
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <span className="text-gray-500">
                            <img
                              src="/download-small-arrow.svg"
                              alt="Dropdown"
                              className="w-2 h-2"
                            />
                          </span>
                        </div>
                        {isOpen && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                            {options.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-black hover:text-white cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadPDF(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Charts Section */}
                  <div className="h-48 md:h-64">
                    <MyChartComponent />
                  </div>

                  {/* Data Table Section */}
                  <div onScroll={handleScroll} className="overflow-x-auto">
                    <table className="w-full h-full border border-gray-200">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr>
                          {breakdownHeaders.map((header) => (
                            <th
                              key={header.label}
                              onClick={() => handleSort(header.key)}
                              className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                            >
                              {/* {header}
            <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                              <div class="flex items-center">
                                <span>{header.label}</span>
                                {header.label != "" && (
                                  <img
                                    src="/sort.svg"
                                    alt="Icon"
                                    class="w-4 h-4 ml-2"
                                  />
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(7)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {filteredData.length > 0 ? (
                            filteredData.map((row) => (
                              <tr className="mb-2 bg-[#F9F9F9]">
                                <td className="px-4 py-2">
                                  {formatDateTime(row.date_created)}
                                </td>

                                {/* Dropdown Button */}
                                <td className="px-4 py-2  relative">
                                  <button
                                    disabled={true}
                                    className={` w-40 text-left font-medium h-10 rounded-xl text-sm px-3 py-4  flex justify-between items-center focus:outline-none${
                                      row.status == "pending"
                                        ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-20"
                                        : ""
                                    }
                              ${
                                row.status == "approved" ||
                                row.status == "approved_for_purchase" ||
                                row.status == "purchased"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#34C046] bg-opacity-20"
                                  : ""
                              }
                              ${
                                row.status == "rejected" ||
                                row.status == "purchase_in_progress" ||
                                row.status == "purchased_partially_failed" ||
                                row.status == "partial_purchase"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#FF5050] bg-opacity-20"
                                  : ""
                              }
                              `}
                                  >
                                    <span className="mr-6">
                                      {" "}
                                      {row.status == "pending" ? "Pending" : ""}
                                      {row.status == "purchased"
                                        ? "Purchased"
                                        : ""}
                                      {row.status == "approved_for_purchase"
                                        ? "Approved For Purchase"
                                        : ""}
                                      {row.status == "purchase_in_progress"
                                        ? "Purchase In Progress"
                                        : ""}
                                      {row.status ==
                                      "purchased_partially_failed"
                                        ? "Purchased Partially Failed"
                                        : ""}
                                      {row.status == "rejected"
                                        ? "Rejected"
                                        : ""}
                                      {row.status == "partial_purchase"
                                        ? "Partial Purchased"
                                        : ""}
                                    </span>
                                  </button>
                                </td>

                                <td className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap">
                                  {row.investor_name}
                                </td>
                                <td className="px-4 py-2 overflow-hidden w-[800px] overflow-hidden text-ellipsis  leading-tight">
                                  {row.product_name}
                                </td>
                                <td className="px-4 py-2 text-center">
                                  <span>
                                    $
                                    {row.amount
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </span>
                                </td>
                                <td className="px-4 py-2 text-center">
                                  $
                                  {(row.cash_account == null
                                    ? 0
                                    : row.cash_account
                                  )
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>

                                <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                                  {row.status == "pending" && (
                                    <span
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleCreateInvestment(row.id);
                                      }}
                                      className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl"
                                    >
                                      Change Status
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center py-4" colSpan="7">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockList;
